import React, { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { googleMapsLoaderOptions } from '../../config/googleMapsLoader';

type GoogleMapsLoaderState = {
  isLoaded: boolean;
  loadError: Error | undefined;
  /** Provider racine qui charge le script Maps. */
  isHost?: boolean;
};

const GoogleMapsLoaderContext = createContext<GoogleMapsLoaderState>({
  isLoaded: false,
  loadError: undefined,
});

function GoogleMapsLoaderActive({ children }: { children: React.ReactNode }) {
  const { isLoaded, loadError } = useJsApiLoader({
    ...googleMapsLoaderOptions,
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '',
  });

  return (
    <GoogleMapsLoaderContext.Provider value={{ isLoaded, loadError, isHost: true }}>
      {children}
    </GoogleMapsLoaderContext.Provider>
  );
}

export function GoogleMapsLoaderProvider({
  enabled,
  children,
}: {
  enabled: boolean;
  children: React.ReactNode;
}) {
  const parent = useContext(GoogleMapsLoaderContext);

  if (!enabled) {
    if (parent.isHost) {
      return <>{children}</>;
    }
    return (
      <GoogleMapsLoaderContext.Provider value={{ isLoaded: false, loadError: undefined }}>
        {children}
      </GoogleMapsLoaderContext.Provider>
    );
  }

  if (parent.isHost) {
    return <>{children}</>;
  }

  return <GoogleMapsLoaderActive>{children}</GoogleMapsLoaderActive>;
}

export function useGoogleMapsLoader(): GoogleMapsLoaderState {
  return useContext(GoogleMapsLoaderContext);
}
